/**
 * Linear Interpolation of a value.
 *
 * @param norm The normalised value (e.g. A ratio, 0.75)
 * @param max The max value to normalise to (will correspond to a norm of 1)
 * @param min The min value to normalise between (will correspond to a norm of 0)
 */
export default (norm, max, min) => (max - min) * norm + min;
